<div class="modal-content">
  <div class="modal-header align-items-center">
    <div class="d-flex flex-column">
      <h2 class="modal-title mb-1">{{ editMode ? ('companyProfile.addDocument.editTitle' | translate) : ('companyProfile.addDocument.title' | translate) }}</h2>
      <p class="text-muted small mb-0">{{ 'common.requiredFields' | translate }}</p>
    </div>
    <i class="fa-solid fa-xmark fs-2 cursor-pointer" (click)="close()"></i>
  </div>

  <div class="modal-body">
    @if (!editMode) {
      <div class="row spacing-20">
        <div class="col-12">
          <h4>{{ 'companyProfile.addDocument.selectFile' | translate }} <span class="text-danger">*</span></h4>
          <p class="text-muted small mb-2">{{ 'companyProfile.addDocument.fileHint' | translate }}</p>
          <app-fileorini
            [accept]="'.pdf,.doc,.docx,.xls,.xlsx,.ppt,.pptx,.txt,.zip,.rar'"
            (filesChanged)="onFileSelected($event)"
            [class.is-invalid]="isFileInvalid"
          />
          @if (isFileInvalid) {
            <div class="text-danger small mt-1">{{ 'companyProfile.addDocument.fileRequired' | translate }}</div>
          }
        </div>
      </div>
    }

    <div class="row spacing-15">
      <div class="col-12">
        <app-input-component
          [label]="('companyProfile.addDocument.documentName' | translate) + ' *'"
          [type]="'text'"
          [placeholder]="'companyProfile.addDocument.documentNamePlaceholder' | translate"
          [(value)]="document_name"
          [invalid]="isDocumentNameInvalid"
        />
      </div>
    </div>
  </div>

  <div class="modal-footer">
    <div class="row">
      <div class="col-12 d-flex justify-content-end gap-2">
        <app-button
          [variant]="'ghost'"
          [label]="'common.cancel' | translate"
          (clicked)="close()"
        />
        <app-button
          [variant]="'primary'"
          [label]="saving ? ('common.saving' | translate) : (editMode ? ('common.saveChanges' | translate) : ('companyProfile.addDocument.upload' | translate))"
          [iconClass]="saving ? 'fa fa-spinner fa-spin' : (editMode ? 'fa fa-save' : 'fa fa-upload')"
          [disabled]="saving"
          (clicked)="onSave()"
        />
      </div>
    </div>
  </div>
</div>
